import { useMutation, useQuery } from "react-query";
import seggregationApi from "../apis/seggregation";
const {
  fetchAllBatches,
  fetchAllClientForSegg,
  getDraftSkuForSegregation,
  getSkuDetail,
  updateProcessFilesOnSku,
  completeDraftSkuOnSegregation,
  listCategoriesForDraftSku,
  listSubCategoriesForDraftSku,
  logoutUser,
  canNotProcessOnSeggregation,
  getCSVForBatchFiles
} = seggregationApi;
// export const useGetAllBatchesForSeggreagtion = (
//   remark,
//   pageNum,
//   pageSize,
//   onSuccess,
//   onError
// ) =>
//   useQuery(
//     ["" + remark, pageNum, pageSize],
//     () => fetchAllBatches(pageNum, pageSize),
//     {
//       onSuccess,
//       onError,
//       refetchOnWindowFocus: false,
//     }
//   );

export const useGetAllBatchesForSeggreagtion = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (pageNum, pageSize) => {
      // console.log(pageNum, pageSize);
      return fetchAllBatches(pageNum, pageSize);
    },
    onSuccess,
    onError,
  });
};
// export const useGetAllClientForSegg = (
//   remark,
//   pageNum,
//   pageSize,
//   onSuccess,
//   onError
// ) =>
//   useQuery(
//     ["" + remark, pageNum, pageSize],
//     () => fetchAllClientForSegg(pageNum, pageSize),
//     {
//       onSuccess,
//       onError,
//       refetchOnWindowFocus: false,
//     }
//   );
export const useGetAllClientForSegg = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (pageNum, pageSize) => {
      return fetchAllClientForSegg(pageNum, pageSize);
    },
    onSuccess,
    onError,
  });
};
export const useGetSkuDetail = (remark, batchId, onSuccess, onError) =>
  useQuery(["" + remark, batchId], () => getSkuDetail(batchId), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
export const useGetDraftSkuForSegregation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return getDraftSkuForSegregation(payload);
    },
    onSuccess,
    onError,
  });
};
export const useUpdateProcessFilesOnSku = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return updateProcessFilesOnSku(payload);
    },
    onSuccess,
    onError,
  });
};
export const useCompleteDraftSkuOnSegregation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return completeDraftSkuOnSegregation(payload);
    },
    onSuccess,
    onError,
  });
};
export const useLogoutUser = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return logoutUser(payload);
    },
    onSuccess,
    onError,
  });
};
export const useGetlistCategories = (remark, draftSkuId, onSuccess, onError) =>
  useQuery(["" + remark, draftSkuId], () => listCategoriesForDraftSku(draftSkuId), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });

export const useGetlistSubCategories = (remark, category, draftSkuId, onSuccess, onError) =>
  useQuery(["" + remark, category, draftSkuId], () => listSubCategoriesForDraftSku(category, draftSkuId), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });

export const useCanNotProcessOnSeggregation = (onSuccess, onError) => {
  return useMutation({
      mutationFn: (skuId) => {
      return canNotProcessOnSeggregation(skuId);
    },
    onSuccess,
    onError,
  });
};
export const useGetCSVForBatchFiles = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (batchId) => {
      return getCSVForBatchFiles(batchId);
    },
    onSuccess,
    onError,
  });
};
